<template>
    <v-tabs>
      <v-tab v-for="game in games" :key="game.title">{{ game.title }}</v-tab>
      <v-tab>Dictionary</v-tab>
      <v-tab-item v-for="game in games" :key="game.id">
        <list-game :game="game"></list-game>
      </v-tab-item>
      <v-tab-item>
        <list-dictionary></list-dictionary>
      </v-tab-item>
    </v-tabs>
</template>

<script>
  import listGame from '@/components/lstGame.vue'
  import listDictionary from '@/components/lstDictionary.vue'
  export default {
    components: {
      listGame,
      listDictionary
    },
    data() {
      return {
        games: [{
          title: 'Alfakodo',
          id: 'alfakodos'
        },
        {
          title: 'Jumble Word',
          id: 'jumblewords'
        },
        {
          title: 'Target Time',
          id: 'targettimes'
        }]
      }
    }
  }
</script>